export default {"src":"/_next/static/media/ensinio_logo.39ed3fae.svg","height":24,"width":82,"blurWidth":0,"blurHeight":0};